<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-row 
            align="center" 
            justify="center"
            style="height: 100vh;">
            <v-col v-if="rps === 'lg'"
              cols="12" 
              md="8" 
              sm="6"
              class="py-0">
              <v-img 
                width="100%"
                height="100vh"
                alt="umb" 
                gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, 0) calc(100% - 600px)"
                :src="require('@/assets/background/basic_bg.jpg')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>

                <div
                  style="position: absolute; bottom: 25px; left: 40px;">
                  <div
                    class="body-2 white--text">
                    Copyright@{{ Object.keys(company).length > 0 ? company.company_name : 'PT Amanata' }} Yogyakarta 2023
                  </div>
                </div>
              </v-img>
            </v-col>

            <v-col 
              cols="12" 
              md="4" 
              sm="6">
              <v-card
                flat
                color="transparent"
                :class="rps === 'lg' ? 'px-16' : 'px-6'">
                <div
                  :class="rps === 'lg' ? 'pr-8' : ''">
                  <div
                    class="pb-16 mb-16">
                    <v-img 
                      contain
                      :width="Object.keys(company).length > 0 ? 350 : 175"
                      height="175"
                      alt="umb" 
                      :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon.svg')"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div v-if="Object.keys(company).length < 1"
                      class="text-h3 font-weight-bold text-center mt-8"
                      :style="`color: ${set_color};`">
                      {{ Object.keys(company).length > 0 ? company.company_name : 'amanata' }}
                    </div>
                  </div>

                  <div>
                    <div
                      class="mb-6">
                      <div
                        class="title font-weight-bold mb-2"
                        :style="`color: ${set_color};`">
                        Masuk
                      </div>

                      <div
                        class="body-2 line-text-first"
                        style="opacity: 60%;">
                        Silahkan masuk menggunakan username yang telah terdaftar.
                      </div>
                    </div>

                    <ValidationObserver 
                      ref="observer">
                      <v-form class="text-left mb-6">
                        <ValidationProvider 
                          name="username" 
                          rules="required" 
                          v-slot="{ errors }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="no_box"
                            solo
                            :color="set_color"
                            placeholder="Username"
                            prepend-inner-icon="mdi-account-outline"

                            v-uppercase

                            v-model="form.username"
                            :error-messages="errors"
                            required>
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          name="password" 
                          rules="required|min:8|max:20" 
                          v-slot="{ errors }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            class="no_box"
                            solo
                            :color="set_color"
                            placeholder="Password"
                            :type="show ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock-outline"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show = !show"
                            :counter="20"

                            v-uppercase
                            
                            v-model="form.password"
                            :error-messages="errors"
                            required>
                          </v-text-field>
                        </ValidationProvider>
                      </v-form>
                    </ValidationObserver>

                    <div 
                      class="text-center mb-6">
                      <div v-if="message.error.length > 0"
                        class="text-center my-4">
                        <div
                          class="error--text d-flex align-center">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>

                      <v-btn
                        v-on:keyup.enter="save"
                        :disabled="process.form"
                        :loading="process.form"
                        @click="save"
                        block
                        x-large
                        width="170"
                        elevation="0"
                        class="title font-weight-bold white--text text-capitalize btn_auth"
                        style="border-radius: 10px;"
                        :style="`background: linear-gradient(180deg, ${set_color_rgb} 0%, ${set_color} 100%);`">
                        <div
                          class="btn_auth_in"
                          :style="`background: linear-gradient(180deg, ${set_color_rgb} 0%, ${set_color_rgb_up} 100%);`">
                          Masuk
                        </div>
                      </v-btn>
                    </div>

                    <div
                      class="body-2 text-center"
                      style="opacity: 60%;">
                      Powered by Amanata
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              let user = res.results.data,
                  menu_arr = res.results.data.menu_array.length < 1 ? [] : res.results.data.menu_array,
                  menu = [
          {
            id: 1,
            title: 'Dashboard',
            icon: 'mdi-view-dashboard-outline',
            link: '/dashboard',
            active: true,
            sub_menu: [],
            action: {}
          },
          {
            id: 12,
            title: 'Dashboard Sentana',
            icon: 'mdi-view-dashboard-outline',
            link: '/dashboard-sentana',
            active: true,
            sub_menu: [],
            action: {}
          },
          {
            id: 2,
            title: 'Struktur Organisasi',
            icon: 'mdi-abacus',
            link: '/unit',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true
            }  
          },
          {
            id: 3,
            title: 'Abdi Dalem',
            icon: 'mdi-account-supervisor-outline',
            link: '/officer',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true,
              aktif: true,
              export: true,
              detail: true
            }
          },
          {
            id: 4, 
            title: 'Sentana',
            icon: 'mdi-account-multiple',
            link: '/sentana',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true,
              aktif: true,
              export: true,
              detail: true
            }
          },
          {
            id: 13,
            title: 'Data Pesan',
            icon: 'mdi-message-text',
            link: '/pesan/data',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              detail: true,
              delete: true
            }
          },
          {
            id: 19,
            title: 'QR Image',
            icon: 'mdi-qrcode',
            link: '/pesan/qr',
            active: false,
            sub_menu: [],
            action: {
              update: true
            }
          },
          {
            id: 14,
            title: 'Kontak',
            icon: 'mdi-card-account-phone',
            link: '/pesan/kontak',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              delete: true,
              update: true
            }
          },
          {
            id: 15,
            title: 'Grup',
            icon: 'mdi-home-group',
            link: '/pesan/grup',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              detail: true,
              update: true,
              delete: true
            }
          },
          {
            id: 16,
            title: 'Kop Undangan',
            icon: 'mdi-file-document',
            link: '/undangan/kop',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 17,
            title: 'Data Undangan',
            icon: 'mdi-file-document',
            link: '/undangan/data',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              preview: true,
              delete: true,
              template: true,
              detail: true
            }
          },
          {
            id: 18,
            title: 'Kawedanan Undangan',
            icon: 'mdi-file-document',
            link: '/undangan/kepaniteraan',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 5,
            title: 'Pencatatan',
            icon: 'mdi-finance',
            link: '/report',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 6,
            title: 'Audit Trail',
            icon: 'mdi-monitor-account',
            link: '/audit',
            active: false,
            sub_menu: [],
            action: {}
          },
          {
            id: 8,
            title: 'Aplikasi',
            icon: 'mdi-cog-outline',
            link: '/konfigurasi/setting',
            active: false,
            sub_menu: [],
            action: {}
          },
          {
            id: 9,
            title: 'Data Trah',
            icon: 'mdi-account-group-outline',
            link: '/konfigurasi/trah/data',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 10,
            title: 'Hak Akses',
            icon: 'mdi-folder-key',
            link: '/konfigurasi/hak-akses',
            active: false,
            sub_menu: [],
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 11,
            title: 'Hak Akses User',
            icon: 'mdi-account-key-outline',
            link: '/konfigurasi/hak-akses-user',
            active: false,
            sub_menu: [],
            action: {
              update: true,
              delete: true
            }
          }
        ]
              
              // if (user.role !== 'viewer') {
              //   menu.push({
              //     id: 7,
              //     title: 'Konfigurasi',
              //     icon: 'mdi-cog-outline',
              //     link: '/konfigurasi',
              //     active: false,
              //     sub_menu: [
              //       {
              //         id: 8,
              //         title: 'Aplikasi',
              //         icon: 'mdi-cog-outline',
              //         link: '/konfigurasi/setting',
              //         active: false,
              //         sub_menu: []
              //       },
              //       {
              //         id: 9,
              //         title: 'Data Trah',
              //         icon: 'mdi-account-group-outline',
              //         link: '/konfigurasi/trah/data',
              //         active: false,
              //         sub_menu: []
              //       },
              //       {
              //         id: 10,
              //         title: 'Hak Akses',
              //         icon: 'mdi-folder-key',
              //         link: '/konfigurasi/hak-akses',
              //         active: false,
              //         sub_menu: []
              //       }
              //     ]
              //   })
              // }

              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : menu)
              )

              TokenService.saveReload(false)

              TokenService.saveFilter(JSON.stringify([]))

              window.location = process.env.VUE_APP_BASE_URL + menu_arr.length > 0 ? menu_arr[0].link : menu[0].link
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      },
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#388E3C')

              this.$store.commit("setColor", '#388E3C')
            }
          }
        })
      }
    }
  }
</script>